import PropTypes from 'prop-types'
import { positionPropType } from '../common/position-prop-type'
import { idPropType } from '../common/id-prop-type'

export const addressPropType = PropTypes.shape({
    addressId: idPropType,
    city: PropTypes.string,
    color: PropTypes.string,
    contact: PropTypes.string,
    countryCode: PropTypes.string,
    email: PropTypes.string,
    fax: PropTypes.string,
    federalState: PropTypes.string,
    info: PropTypes.string,
    lastModified: PropTypes.number,
    location: PropTypes.string,
    mapcode: PropTypes.string,
    name1: PropTypes.string,
    name2: PropTypes.string,
    name3: PropTypes.string,
    number: PropTypes.string,
    position: positionPropType,
    radius: PropTypes.number,
    street: PropTypes.string,
    telMobile: PropTypes.string,
    telOffice: PropTypes.string,
    telPrivate: PropTypes.string,
    visible: PropTypes.bool,
    zip: PropTypes.string
})
